import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import type { ReactNode } from "react";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

export type PageListContainerProps = {
  children: ReactNode;
  /**
   * `plain` (default) — layout stack only; use PageSectionCard for surfaces.
   * `panel` — single Win11 soft panel wrapping the whole page body.
   */
  surface?: "panel" | "plain";
};

/**
 * Page body stack for list/settings/edit screens.
 * Avoids card-in-card: default is a compact vertical stack on the app canvas.
 */
function PageListContainer({ children, surface = "plain" }: PageListContainerProps) {
  const custom = useAppCustomStyles();
  const stackSx = custom.components.layout.pageListStack;

  if (surface === "panel") {
    return (
      <Paper elevation={0} sx={[custom.page.listPageContainer, stackSx]}>
        {children}
      </Paper>
    );
  }

  return <Box sx={[custom.components.layout.pageListPlainOuter, stackSx]}>{children}</Box>;
}

export default PageListContainer;
